import { render, staticRenderFns } from "./shareiconButton.vue?vue&type=template&id=07cfe422&scoped=true&"
import script from "./shareiconButton.vue?vue&type=script&lang=js&"
export * from "./shareiconButton.vue?vue&type=script&lang=js&"
import style0 from "./shareiconButton.vue?vue&type=style&index=0&id=07cfe422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfe422",
  null
  
)

export default component.exports